/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserIntegrationInfo} from '../models/UserIntegrationInfo';

export interface GetUserIntegrationInfo$Request {
    userId: number;
}

export interface GetUserIntegrationInfo$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserIntegrationInfoRequest = createAction<PayloadData<void, GetUserIntegrationInfo$Request>>('GET_USER_INTEGRATION_INFO__GET_USER_INTEGRATION_INFO__REQUEST');
export const getUserIntegrationInfoSuccess = createAction<PayloadData<UserIntegrationInfo, GetUserIntegrationInfo$Request>>('GET_USER_INTEGRATION_INFO__GET_USER_INTEGRATION_INFO__SUCCESS');
export const getUserIntegrationInfoFailure = createAction<PayloadData<Error, GetUserIntegrationInfo$Request, true>>('GET_USER_INTEGRATION_INFO__GET_USER_INTEGRATION_INFO__FAILURE');

export const getUserIntegrationInfoActions = [
    getUserIntegrationInfoRequest,
    getUserIntegrationInfoSuccess,
    getUserIntegrationInfoFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserIntegrationInfo = (meta: GetUserIntegrationInfo$Request, config?: GetUserIntegrationInfo$Config) => {
    return {
        CALL_API: {
            types: getUserIntegrationInfoActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/integration-info`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

